import React, { Component } from 'react';
import { Row, Col, Card, Alert, Button, Divider } from "antd";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { loginUser, apiError } from '../../store/actions';
import { CheckOutlined } from '@ant-design/icons';



class LoginNew extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        }

        this.handleValidSubmit = this.handleValidSubmit.bind(this);
    };


    handleValidSubmit(event, values) {
        this.setState({ loading: true }, () => {
            this.props.loginUser(values, this.props.history)
        })
    };


    componentDidMount() {
        this.props.apiError("");
    };


    render() {
        return (
            <Row
                gutter={24}
                className="m-0 p-0 w-100 h-100"
                align="middle"
                style={{ background: "radial-gradient(#ba174d, #750b24)" }}
            >
                <Col xl={9} lg={8} md={6} sm={0} xs={0} />
                <Col xl={6} lg={8} md={12} sm={24} xs={24} className="align-item-center justify-content-center">
                    <Row gutter={24} align="middle">
                        <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                            <Card
                                hoverable
                                className="overflow-hidden m-0 p-0"
                                style={{ borderRadius: "10px", boxShadow: "0 0 40px rgba(0,0,0,0.7)" }}
                                bodyStyle={{ padding: "0" }}
                            >
                                <Row gutter={24} className="m-0 p-0">
                                    <Col span={24} className="m-0 p-0">
                                        <Row gutter={24} className="text-center m-3">
                                            <Col span={24}>
                                                <img src='/img/logo.png' style={{ width: "40%" }} alt='PS Logo' />
                                            </Col>
                                        </Row>
                                        <Divider className="w-100" style={{ color: "#a461d8", backgroundColor: "#a461d8" }} />
                                        <Row gutter={24} className="m-3">
                                            <Col span={24} className="text-center">
                                                <h4 className='font-weight-bold'>Mirë se erdhët!</h4>
                                                <p className='font-weight-bold m-0 p-0'>Vendosni kredencialet për të hyrë!</p>
                                            </Col>
                                        </Row>
                                        <Row gutter={24} className="text-left">
                                            <Col span={20} offset={2}>
                                                <div className="p-2">
                                                    <AvForm className="form-horizontal mt-0"
                                                        onValidSubmit={this.handleValidSubmit}>

                                                        {this.props.error && this.props.error ? (
                                                            <Alert type="error" message={this.props.error} />
                                                        ) : (
                                                            null
                                                        )}

                                                        <div className="form-group">
                                                            <AvField
                                                                style={{ padding: "10px 10px" }}
                                                                errorMessage="Ju lutemi vendosni username ose kodin  e përdoruesit!"
                                                                name="username"
                                                                label="Përdoruesi"
                                                                value=""
                                                                className="form-control"
                                                                placeholder="Përdoruesi..."
                                                                type="text"
                                                                required
                                                                onChange={() => {
                                                                    this.setState({ loading: false }, () => {
                                                                        this.props.apiError("")
                                                                    })
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <AvField
                                                                style={{ padding: "10px 10px" }}
                                                                errorMessage="Ju lutemi vendosni fjalëkalimin!"
                                                                name="password"
                                                                label="Fjalëkalimi"
                                                                value=""
                                                                type="password"
                                                                // type="text"
                                                                required
                                                                placeholder="Fjalëkalimi..."
                                                                // onChange={()=>this.props.apiError("")}
                                                                onChange={() => {
                                                                    this.setState({ loading: false }, () => {
                                                                        this.props.apiError("")
                                                                    })
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="mt-3 mb-3">
                                                            <Button
                                                                type="primary"
                                                                loading={this.state.loading && !this.props.error}
                                                                size="large"
                                                                style={{ borderRadius: "10px", backgroundColor: "#ba174d" }}
                                                                htmlType="submit"
                                                                block
                                                                icon={<CheckOutlined />}
                                                            >
                                                                Hyr
                                                            </Button>
                                                        </div>
                                                    </AvForm>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>
                </Col>
            </Row>
        );
    };
};


const mapStatetoProps = state => {
    const { error } = state.Login;
    return { error };
};


export default withRouter(connect(mapStatetoProps, { loginUser, apiError })(LoginNew));